/* Coty Optique — coloris : pastilles diagonales (matière recréée / couleur), détourage à cadrage fixe, transition premium */
(() => {
  'use strict';
  if (window.cotyColor) return;

  const SS = 'cotyCol9:';

  /* ---------- Traitements lourds hors du fil principal (Web Worker + OffscreenCanvas) ----------
     Le détourage, l'analyse des coloris et les matières tournaient sur le fil principal (jusqu'à
     plusieurs centaines de ms par photo sur mobile) : chaque toucher attendait la fin de ces calculs (INP). */
  const SELF = (document.currentScript && document.currentScript.src) || '';
  const WORKER_URL = window.cotyFxWorker || (SELF ? SELF.replace(/coty-color\.js/, 'coty-fx-worker.js') : '');
  const abs = u => { try { return new URL(u, location.href).href; } catch (e) { return u; } };
  let W = null, wid = 0; const pend = new Map();
  const worker = () => {
    if (W !== null) return W; W = false;
    try {
      if (!WORKER_URL || !window.Worker || !window.OffscreenCanvas || !window.createImageBitmap) return W;
      const boot = URL.createObjectURL(new Blob(['importScripts(' + JSON.stringify(abs(WORKER_URL)) + ')'], { type: 'text/javascript' }));
      W = new Worker(boot);
      W.onmessage = e => { const p = pend.get(e.data.id); if (!p) return; pend.delete(e.data.id); e.data.ok ? p.res(e.data.out) : p.rej(new Error(e.data.err)); };
      W.onerror = ev => { if (ev && ev.preventDefault) ev.preventDefault(); W = false; pend.forEach(p => p.rej(new Error('worker'))); pend.clear(); };
    } catch (e) { W = false; }
    return W;
  };
  const call = (op, a) => new Promise((res, rej) => {
    const w = worker(); if (!w) return rej(new Error('noworker'));
    const id = ++wid; pend.set(id, { res, rej }); w.postMessage({ id, op, a });
  });
  // secours (navigateurs sans worker) : un traitement à la fois, lancé quand le navigateur est libre
  let chain = Promise.resolve();
  const idle = () => new Promise(r => (window.requestIdleCallback ? requestIdleCallback(() => r(), { timeout: 400 }) : setTimeout(r, 30)));
  const queued = fn => (chain = chain.then(idle).then(fn, fn).catch(() => null), chain);
  const blobUrl = b => (b instanceof Blob ? URL.createObjectURL(b) : b);
  const load = src => new Promise((res, rej) => { const im = new Image(); im.crossOrigin = 'anonymous'; im.decoding = 'async'; im.onload = () => res(im); im.onerror = rej; im.src = src; });
  const draw = (im, W) => {
    const H = Math.round(im.naturalHeight * W / im.naturalWidth);
    const c = document.createElement('canvas'); c.width = W; c.height = H;
    const x = c.getContext('2d', { willReadFrequently: true }); x.drawImage(im, 0, 0, W, H);
    return { c, x, W, H, d: x.getImageData(0, 0, W, H) };
  };
  const bbox = (d, W, H, thr = 225) => {
    const p = d.data; let x0 = W, y0 = H, x1 = 0, y1 = 0;
    for (let y = 0; y < H; y++) for (let x = 0; x < W; x++) {
      const i = (y * W + x) * 4;
      if (p[i + 3] > 200 && Math.min(p[i], p[i + 1], p[i + 2]) < thr) { if (x < x0) x0 = x; if (x > x1) x1 = x; if (y < y0) y0 = y; if (y > y1) y1 = y; }
    }
    return x1 - x0 < 10 || y1 - y0 < 6 ? null : { x0, y0, x1, y1 };
  };
  const avg = (p, W, pts) => {
    let r = 0, g = 0, b = 0, n = 0;
    pts.forEach(([x, y]) => { const i = (y * W + x) * 4; r += p[i]; g += p[i + 1]; b += p[i + 2]; n++; });
    return n ? [r / n, g / n, b / n] : null;
  };

  /* Analyse d'une photo de coloris → palette de la monture (sombre / base / claire) et teinte du verre */
  const memo = new Map();
  const rgb = a => `rgb(${a.map(v => Math.round(v)).join(',')})`;
  function analyze(src) {
    if (!src) return Promise.resolve(null);
    if (memo.has(src)) return memo.get(src);
    const p = (async () => {
      try { const s = sessionStorage.getItem(SS + src); if (s) return JSON.parse(s); } catch (e) {}
      try { const w = await call('analyze', { src: abs(src) }); try { sessionStorage.setItem(SS + src, JSON.stringify(w)); } catch (e) {} return w; } catch (e) {}
      await queued(() => 0);
      const im = await load(src);
      const { W, H, d } = draw(im, 400), px = d.data;
      const b = bbox(d, W, H); if (!b) return null;
      const bw = b.x1 - b.x0, bh = b.y1 - b.y0;
      const lx = Math.round(b.x0 + bw * .24), rx = Math.round(b.x0 + bw * .76), ly = Math.round((b.y0 + b.y1) / 2), r = Math.max(2, Math.round(bh * .12));
      const lens = []; for (let y = ly - r; y <= ly + r; y++) for (let x = lx - r; x <= lx + r; x++) if ((x - lx) ** 2 + (y - ly) ** 2 <= r * r && x >= 0 && y >= 0 && x < W && y < H) lens.push([x, y]);
      const lc = avg(px, W, lens);
      const clear = !lc || ((lc[0] + lc[1] + lc[2]) / 3 > 168 && Math.max(...lc) - Math.min(...lc) < 22);
      // pixels de monture : hors centre des verres, hors fond, hors teinte du verre
      const fr = [], R2 = (bh * .4) ** 2;
      for (let y = b.y0; y <= b.y1; y += 2) for (let x = b.x0; x <= b.x1; x += 2) {
        const i = (y * W + x) * 4; if (Math.min(px[i], px[i + 1], px[i + 2]) > 205) continue;
        if ((x - lx) ** 2 + (y - ly) ** 2 < R2 || (x - rx) ** 2 + (y - ly) ** 2 < R2) continue;
        if (!clear && Math.hypot(px[i] - lc[0], px[i + 1] - lc[1], px[i + 2] - lc[2]) < 40) continue;
        fr.push([x, y]);
      }
      const lum = q => { const i = (q[1] * W + q[0]) * 4; return px[i] * .3 + px[i + 1] * .59 + px[i + 2] * .11; };
      fr.sort((u, v) => lum(u) - lum(v));
      const pick = (a, z) => avg(px, W, fr.slice(Math.floor(fr.length * a), Math.max(Math.floor(fr.length * a) + 1, Math.floor(fr.length * z))));
      const dark = pick(0, .2) || [40, 30, 25], base = pick(.15, .55) || dark, light = pick(.7, .95) || base;
      const out = { dark: rgb(dark), base: rgb(base), light: rgb(light), c: rgb(clear ? base : lc), raw: { dark, base, light } };
      try { sessionStorage.setItem(SS + src, JSON.stringify(out)); } catch (e) {}
      return out;
    })().catch(() => null);
    memo.set(src, p); return p;
  }

  /* ---------- Matières recréées (rendu procédural, pas de photo) ---------- */
  const norm = s => (s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '');
  function materialOf(name) {
    const f = norm((name || '').split(' / ')[0]);
    if (/ray/.test(f)) return 'stripe';
    if (/ecaille|havan|tortoise|mahogany|tabac|corne/.test(f)) return 'tortoise';
    if (/metal|\bor\b|dore|argent|pallad|leton|laiton|ruthen|gunmetal|titane|acier/.test(f)) return 'metal';
    if (/opal|lait|laiteux|lie de vin/.test(f)) return 'opal';
    if (/transparent|cristal|crystal|chanvre|sable/.test(f)) return 'clear';
    if (/inject|\bmat\b|mate\b/.test(f)) return 'matte';
    return 'gloss';
  }
  const hash = s => { let h = 2166136261; for (let i = 0; i < s.length; i++) { h ^= s.charCodeAt(i); h = Math.imul(h, 16777619); } return h >>> 0; };
  function noiseGen(seed) {
    const N = 64, g = new Float32Array(N * N); let x = seed || 1;
    for (let i = 0; i < g.length; i++) { x ^= x << 13; x ^= x >>> 17; x ^= x << 5; g[i] = ((x >>> 0) % 10000) / 10000; }
    const at = (i, j) => g[((j % N + N) % N) * N + ((i % N + N) % N)];
    const sm = t => t * t * (3 - 2 * t);
    const v = (x, y) => { const i = Math.floor(x), j = Math.floor(y), fx = sm(x - i), fy = sm(y - j);
      const a = at(i, j), b = at(i + 1, j), c = at(i, j + 1), d = at(i + 1, j + 1);
      return a + (b - a) * fx + (c - a) * fy + (a - b - c + d) * fx * fy; };
    return (x, y, o = 4) => { let s = 0, amp = .5, f = 1; for (let k = 0; k < o; k++) { s += amp * v(x * f, y * f); amp *= .5; f *= 2; } return s / (1 - Math.pow(.5, o)); };
  }
  const mix = (a, b, t) => [a[0] + (b[0] - a[0]) * t, a[1] + (b[1] - a[1]) * t, a[2] + (b[2] - a[2]) * t];
  const ramp = (stops, t) => { t = Math.max(0, Math.min(1, t)); for (let i = 1; i < stops.length; i++) if (t <= stops[i][0]) { const [t0, c0] = stops[i - 1], [t1, c1] = stops[i]; return mix(c0, c1, (t - t0) / ((t1 - t0) || 1)); } return stops[stops.length - 1][1]; };
  const warm = (c, k) => { const g = (c[0] + c[1] + c[2]) / 3; return c.map(v => Math.max(0, Math.min(255, g + (v - g) * k))); };
  const lift = (c, k) => c.map(v => Math.max(0, Math.min(255, v + (k > 0 ? (255 - v) * k : v * k))));
  const texCache = new Map();
  function material(name, pal, S = 192) {
    const key = name + '|' + pal.base + '|' + pal.light; if (texCache.has(key)) return texCache.get(key);
    const kind = materialOf(name), seed = hash(name), n = noiseGen(seed), n2 = noiseGen(seed ^ 0x9e3779b9);
    const { dark, base, light } = pal.raw;
    const c = document.createElement('canvas'); c.width = c.height = S; const x = c.getContext('2d');
    const img = x.createImageData(S, S), p = img.data;
    for (let j = 0; j < S; j++) for (let i = 0; i < S; i++) {
      const u = i / S, v = j / S; let col;
      if (kind === 'tortoise') {
        const wx = n2(u * 3, v * 3, 3) * 2.2, wy = n2(u * 3 + 7, v * 3 + 3, 3) * 2.2;
        const t = n(u * 4.2 + wx, v * 4.2 + wy, 5);
        col = ramp([[0, lift(dark, -.45)], [.4, lift(dark, -.15)], [.5, mix(warm(base, 1.5), [118, 60, 22], .3)], [.6, mix(warm(light, 1.6), [204, 128, 44], .38)], [1, lift(mix(warm(light, 1.6), [214, 150, 60], .4), .2)]], (t - .3) / .45);
      } else if (kind === 'stripe') {
        const w = n(u * 2, v * 6, 3) * 1.6, t = .5 + .5 * Math.sin((v * 9 + w) * Math.PI);
        col = ramp([[0, dark], [.45, base], [.8, light], [1, lift(light, .25)]], t * .85 + n2(u * 20, v * 4, 2) * .15);
      } else if (kind === 'opal') {
        const t = n(u * 2.2, v * 2.2, 4);
        col = ramp([[0, base], [.55, lift(base, .25)], [1, lift(light, .45)]], t);
      } else if (kind === 'clear') {
        const t = n(u * 2, v * 2, 3) * .25 + (1 - Math.abs(u - v)) * .1;
        col = mix(lift(light, .55), base, .35 + t);
      } else if (kind === 'metal') {
        const brush = n(u * 1.2, v * 90, 2) * .18 + n2(u * 3, v * 260, 1) * .08;
        const band = .5 + .5 * Math.cos((u * .8 + v * 1.4) * Math.PI * 1.6);
        col = ramp([[0, lift(dark, -.1)], [.4, base], [.75, light], [1, lift(light, .55)]], band * .82 + brush);
      } else if (kind === 'matte') {
        col = lift(base, (n(u * 30, v * 30, 2) - .5) * .08);
      } else {
        col = lift(base, (n(u * 25, v * 25, 2) - .5) * .05 + (.5 - (u + v) / 2) * .18);
      }
      const k = (j * S + i) * 4; p[k] = col[0]; p[k + 1] = col[1]; p[k + 2] = col[2]; p[k + 3] = 255;
    }
    x.putImageData(img, 0, 0);
    // vernis : reflet doux (acétate brillant) ou bande spéculaire (métal) ; aucun pour le mat
    if (kind !== 'matte') {
      const g = x.createLinearGradient(0, 0, S, S);
      const a = kind === 'metal' ? .45 : kind === 'clear' ? .55 : .3;
      g.addColorStop(0, `rgba(255,255,255,${a * .5})`); g.addColorStop(.28, 'rgba(255,255,255,0)'); g.addColorStop(.42, `rgba(255,255,255,${a})`); g.addColorStop(.5, 'rgba(255,255,255,0)'); g.addColorStop(1, 'rgba(0,0,0,.12)');
      x.fillStyle = g; x.fillRect(0, 0, S, S);
    }
    if (kind === 'clear') { x.strokeStyle = 'rgba(255,255,255,.7)'; x.lineWidth = S * .018; x.beginPath(); x.moveTo(S * .1, S * .62); x.lineTo(S * .62, S * .1); x.stroke(); }
    const url = c.toDataURL('image/png'); texCache.set(key, url); return url;
  }
  /* Pastille / tuile en diagonale : matière recréée en haut à gauche, couleur en bas à droite */
  function paint(el, src, name) {
    if (!el) return Promise.resolve();
    name = name || el.dataset.value || el.getAttribute('title') || el.getAttribute('aria-label') || '';
    return analyze(src).then(async r => {
      if (!r) return;
      const key = name + '|' + r.base + '|' + r.light;
      let t = texCache.get(key);
      if (!t) {
        try { t = blobUrl(await call('material', { name, pal: { base: r.base, light: r.light, raw: r.raw } })); texCache.set(key, t); }
        catch (e) { t = await queued(() => material(name, r)); }
      }
      if (!t) return;
      el.style.background = `linear-gradient(135deg, transparent 0 49.4%, rgba(255,255,255,.6) 49.4% 50.6%, ${r.c} 50.6% 100%), url(${t}) center / cover no-repeat`;
      el.classList.add('is-photo'); el.dataset.material = materialOf(name);
    });
  }

  /* Détourage sur fond blanc, recalé sur la photo de référence : même largeur de monture, même centre
     (les photos des coloris n'ont pas toujours le même cadrage) → la paire ne change jamais de taille */
  const cuts = new Map(), boxes = new Map();
  function refBox(ref) {
    if (boxes.has(ref)) return boxes.get(ref);
    const p = load(ref).then(im => { const { W, H, d } = draw(im, 900); const b = bbox(d, W, H, 229); return b && { x: b.x0, y: b.y0, w: b.x1 - b.x0, h: b.y1 - b.y0, W, H }; }).catch(() => null);
    boxes.set(ref, p); return p;
  }
  function cutoutLike(src, ref, full) {
    const key = src + '|' + ref + '|' + (full ? 1 : 0); if (cuts.has(key)) return cuts.get(key);
    const p = (async () => {
      try { return blobUrl(await call('cut', { src: abs(src), ref: abs(ref || src), full: !!full })); } catch (e) {}
      return queued(() => cutMain(src, ref, full));
    })().catch(() => src);
    cuts.set(key, p); return p;
  }
  async function cutMain(src, ref, full) {
    {
      const [im, rb] = await Promise.all([load(src), refBox(ref || src)]);
      const { c, x, W, H, d } = draw(im, 900), px = d.data;
      const ob = bbox(d, W, H, 229) || { x0: 0, y0: 0, x1: W - 5, y1: H - 5 };
      const ci = [[1, 1], [W - 2, 1], [1, H - 2], [W - 2, H - 2]].map(([a, b]) => (b * W + a) * 4);
      let br = 0, bg = 0, bb = 0; ci.forEach(i => { br += px[i]; bg += px[i + 1]; bb += px[i + 2]; }); br /= 4; bg /= 4; bb /= 4;
      if (br > 225 && bg > 225 && bb > 225) {
        for (let i = 0; i < px.length; i += 4) {
          const dd = Math.max(br - px[i], bg - px[i + 1], bb - px[i + 2], 0) / 255;
          const a = Math.min(1, Math.max(0, (dd - .012) * 5.2));
          if (a <= 0) { px[i + 3] = 0; continue; }
          if (a < 1) { px[i] = Math.max(0, Math.min(255, (px[i] - (1 - a) * br) / a)); px[i + 1] = Math.max(0, Math.min(255, (px[i + 1] - (1 - a) * bg) / a)); px[i + 2] = Math.max(0, Math.min(255, (px[i + 2] - (1 - a) * bb) / a)); }
          px[i + 3] = Math.round(a * 255);
        }
        x.putImageData(d, 0, 0);
      }
      const r = rb || { x: ob.x0, y: ob.y0, w: ob.x1 - ob.x0, h: ob.y1 - ob.y0, W, H };
      const sw = ob.x1 - ob.x0 + 5, sh = ob.y1 - ob.y0 + 5, tw = r.w + 5, th = r.h + 5;
      const o = document.createElement('canvas');
      if (full) { o.width = r.W; o.height = r.H; } else { o.width = tw; o.height = th; }
      const tx = full ? r.x - 2 : 0, ty = full ? r.y - 2 : 0;
      const k = Math.min(tw / sw, th / sh), dw = sw * k, dh = sh * k;
      const g = o.getContext('2d'); g.imageSmoothingQuality = 'high';
      g.drawImage(c, Math.max(0, ob.x0 - 2), Math.max(0, ob.y0 - 2), sw, sh, tx + (tw - dw) / 2, ty + (th - dh) / 2, dw, dh);
      return o.toDataURL('image/png');
    }
  }

  /* Transition de coloris : l'ancienne teinte s'efface (flou + léger recul), puis la nouvelle apparaît
     avec un reflet qui balaie la monture — jamais deux images superposées */
  const css = document.createElement('style');
  css.textContent = `
.cc-sheen{position:absolute;pointer-events:none;z-index:3;background:linear-gradient(105deg,transparent 0 44%,rgba(255,255,255,.7) 50%,transparent 56% 100%);background-size:300% 100%;background-position:100% 0;-webkit-mask-size:100% 100%;mask-size:100% 100%;-webkit-mask-repeat:no-repeat;mask-repeat:no-repeat;mix-blend-mode:screen;animation:ccSheen .9s cubic-bezier(.4,0,.2,1) forwards}
@keyframes ccSheen{0%{opacity:0}20%{opacity:1}80%{opacity:1}to{background-position:0 0;opacity:0}}
@media (prefers-reduced-motion: reduce){.cc-sheen{display:none}}`;
  document.head.appendChild(css);
  const reduce = () => matchMedia('(prefers-reduced-motion: reduce)').matches;
  const place = (el, img) => {
    Object.assign(el.style, { left: img.offsetLeft + 'px', top: img.offsetTop + 'px', width: img.offsetWidth + 'px', height: img.offsetHeight + 'px' });
    img.insertAdjacentElement('afterend', el);
  };
  const sheen = (img, maskUrl) => {
    if (reduce()) return;
    const s = document.createElement('span'); s.className = 'cc-sheen';
    if (maskUrl) { s.style.webkitMaskImage = `url("${maskUrl}")`; s.style.maskImage = `url("${maskUrl}")`; }
    place(s, img); setTimeout(() => s.remove(), 1000);
  };
  const OUT = [{ opacity: 1, filter: 'blur(0px) brightness(1)', transform: 'scale(1)' }, { opacity: 0, filter: 'blur(7px) brightness(1.12)', transform: 'scale(.965)' }];
  const IN = [{ opacity: 0, filter: 'blur(7px) brightness(1.12)', transform: 'scale(1.025)' }, { opacity: 1, filter: 'blur(0px) brightness(1)', transform: 'scale(1)' }];
  const run = (el, kf, ms, ez) => el.animate ? el.animate(kf, { duration: reduce() ? 1 : ms, easing: ez, fill: 'both' }).finished.catch(() => {}) : Promise.resolve();
  const ready = url => new Promise(res => { const n = new Image(); n.onload = n.onerror = () => (n.decode ? n.decode().catch(() => {}) : Promise.resolve()).then(res); n.src = url; });
  const seq = new WeakMap();
  /* Remplace l'image `img` par `url` (même cadrage) : sortie puis entrée, sans fondu croisé */
  async function morphTo(img, url, withSheen = true) {
    if (!img || !url) return;
    const id = (seq.get(img) || 0) + 1; seq.set(img, id);
    await ready(url); if (seq.get(img) !== id) return;
    await run(img, OUT, 260, 'cubic-bezier(.4,0,1,1)'); if (seq.get(img) !== id) return;
    img.src = url; await (img.decode ? img.decode().catch(() => {}) : 0);
    run(img, IN, 560, 'cubic-bezier(.16,.84,.3,1)');
    if (withSheen) setTimeout(() => seq.get(img) === id && sheen(img, url), 160);
  }

  /* Fiche produit : au changement de coloris, la photo est détourée et recalée sur la première
     (même taille, même position), puis passe par la même transition */
  function watchGallery(img) {
    if (!img || img.dataset.ccWatch) return; img.dataset.ccWatch = '1';
    const ref = img.currentSrc || img.src;
    let shown = ref, colorClick = 0, mine = '', cover = null, tok = 0;
    document.addEventListener('click', e => { if (e.target.closest('[data-tex] [data-option-btn]')) colorClick = performance.now(); }, true);
    new MutationObserver(() => {
      const now = img.getAttribute('src'); if (!now || now === mine || now === shown) return;
      const fromColor = performance.now() - colorClick < 1500, prev = shown, my = ++tok; shown = now;
      // l'ancienne photo reste affichée (copie fixe) pendant la préparation, la nouvelle est masquée
      if (!cover) { cover = document.createElement('img'); cover.alt = ''; cover.className = img.className; cover.removeAttribute('data-gallery-main'); cover.style.position = 'absolute'; cover.style.pointerEvents = 'none'; cover.src = prev; place(cover, img); }
      img.style.visibility = 'hidden';
      const finish = async u => {
        if (my !== tok) return;
        if (u !== now) { mine = u; img.removeAttribute('srcset'); img.src = u; shown = u; }
        await (img.decode ? img.decode().catch(() => {}) : 0); if (my !== tok) return;
        await run(cover, OUT, 260, 'cubic-bezier(.4,0,1,1)'); if (my !== tok) return;
        cover.remove(); cover = null;
        img.style.visibility = '';
        run(img, IN, 560, 'cubic-bezier(.16,.84,.3,1)');
      };
      (fromColor ? cutoutLike(now, ref, true) : Promise.resolve(now)).then(finish);
    }).observe(img, { attributes: true, attributeFilter: ['src'] });
  }

  /* Pastilles des carrousels (créées en JS) : on reprend le nom du coloris depuis le titre */
  window.cotyColor = { analyze, paint, material, materialOf, cutoutLike, morphTo, watchGallery };

  const boot = () => {
    document.querySelectorAll('[data-tex] [data-tile-src]').forEach(b => paint(b, b.dataset.tileSrc, b.dataset.value));
    document.querySelectorAll('[data-gallery-main]').forEach(watchGallery);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
